import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useProducts} from '@salesforce/commerce-sdk-react'
import ProductScroller from '../../../product-scroller'
import {useGlobaleContext} from '../../../../contexts/globale'
import {SELECTED_ATTRIBUTES_WIDGET_PRODUCTS} from '../../../../constants'
import {isServer} from '@salesforce/retail-react-app/app/utils/utils'

export const Recommendations = ({
    title,
    titleColor = 'black',
    titleTag = 'h2',
    dataLayerLoaded = true,
    titleFontFamily,
    analyticsProps = {},
    ...rest
}) => {
    const selectedAttributes = SELECTED_ATTRIBUTES_WIDGET_PRODUCTS
    const productIds = []
    const {countryISO, currencyCode} = useGlobaleContext()
    let index = 1
    while (`product${index}` in rest) {
        productIds.push(rest[`product${index}`])
        delete rest[`product${index}`] // Avoid modifying rest if unnecessary
        index++
    }
    const enabledRecommendations = Boolean(productIds.length) && !isServer // This is always below the fold, so its ok to trigger this on client side
    const {data: products, isLoading} = useProducts(
        {
            parameters: {
                ids: productIds.join(','),
                expand: ['availability', 'links', 'promotions', 'images', 'prices', 'variations'],
                select: selectedAttributes,
                perPricebook: true,
                allVariationProperties: true,
                allImages: true,
                c_selectedCountry: countryISO,
                c_selectedCurrency: currencyCode
            }
        },
        {
            enabled: enabledRecommendations
        }
    )

    if (productIds.length === 0) {
        return null
    }

    const trackingProps = {
        component_id: analyticsProps?.componentType || rest.typeId,
        component_name: title || analyticsProps?.componentName || rest.name || rest.typeId
    }

    return (
        <Box>
            <ProductScroller
                title={title}
                titleFontFamily={titleFontFamily}
                titleColor={titleColor === 'black' ? 'black' : titleColor}
                titleTag={titleTag}
                dataLayerLoaded={dataLayerLoaded}
                products={products?.data}
                isLoading={isLoading}
                enableFavourite={true}
                hideArrows={false}
                showImageSlider={true}
                sliderGroup="product"
                analyticsProps={trackingProps}
            />
        </Box>
    )
}

Recommendations.propTypes = {
    title: PropTypes.string,
    titleColor: PropTypes.string,
    dataLayerLoaded: PropTypes.bool,
    titleFontFamily: PropTypes.string,
    titleTag: PropTypes.string,
    products: PropTypes.arrayOf(PropTypes.object),
    analyticsProps: PropTypes.object
}

export default Recommendations
